import { Input } from "antd";
import React, { FC } from "react";
import "./searchInput.scss";
import { SearchOutlined } from "@ant-design/icons";
interface SearchInputProps {
  placeholder: string;
  onChange: (value: any) => void;
}
export const SearchInput: FC<SearchInputProps> = ({
  placeholder,
  onChange,
}) => {
  return (
    <Input
      prefix={<SearchOutlined/>}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className="search-input__container"
    />
  );
};
